module.exports = __webpack_public_path__ + "img/group_m5.28bb9daf.png";